<template>
    <service-screen-layout :parts="parts">
        <template v-slot:monitoring>
            <div class="col-md-12">
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Description</label>
                        <input type="text" class="form-control" v-model="saleDefinition.definition.monitoringConfig.description" disabled>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-6">
                        <label>Package</label>
                        <div class="input-group">
                            <input type="text" class="form-control" v-model="saleDefinition.definition.monitoringConfig.monitoringPackage.description" disabled>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:regrade>
            <div class="row">
                <div class="col-md-12">
                    <BasicPackageChanges
                        :heading="'Regrade'"
                        @packageChange="packageChange"
                        :availablePackages="saleDefinition.selectableOptions.monitoringPackage"
                        :packageChanges="saleDefinition.definition.monitoringConfig.packageChangeInstructions"
                    />
                </div>
            </div>
        </template>
    </service-screen-layout>
</template>

<script>
import SaleFunctions from "@/pages/Services/SaleFunctions";
import ServiceScreenLayout from "@/layouts/ServiceScreenLayout";
import BasicPackageChanges from "@/components/ObjParts/MultipleCaptured/BasicPackageChanges";

export default {
    extends: SaleFunctions,
    components: {
        ServiceScreenLayout,
        BasicPackageChanges
    },
    data() {
        return {
            parts: [
                {
                    name: "monitoring",
                    icon: "fa-solid fa-gauge",
                    displayName: "Monitoring Service",
                    permissions: ["*"],
                },
                {
                    name: "regrade",
                    icon: "fa fa-arrows-v",
                    displayName: "Regrade",
                    permissions: ["*"],
                },
            ],
            saleNumber: null,
            saleDefinition: {
                definition: {
                    monitoringConfig: {
                        monitoringPackage: {
                            description: ""
                        },
                        packageChangeInstructions: []
                    }
                },
                selectableOptions: {
                    monitoringPackage: []
                }
            },
        }
    },
    mounted() {
        this.saleNumber = this.$route.params.saleNumber;
        this.getSale();
    },
    methods: {
        getSale: function() {
            const hostUrl = this.$config.aimsAPI;

            this.$http.get(`${hostUrl}sales/definition/sale/${this.saleNumber}`).then(
                (response) => {
                    this.saleDefinition = response.data;
                },
                (error) => {
                    console.error(error);
                    this.showError("Error fetching Sale Definition", error);
                }
            );
        },
        packageChange: function (packageChange, immediate) {
            let changePackageInstruction = this.deepCopyObject(this.saleDefinition.supportingObjs.packageChangeInstructions);
            changePackageInstruction.monitoringConfigNumber =  this.saleDefinition.definition.monitoringConfig.monitoringConfigNumber;
            changePackageInstruction.basicPackageNumber = packageChange.objKey;
            if (immediate) {
                changePackageInstruction.billingPeriod = this.getCurrentPeriod();
            } else {
                changePackageInstruction.billingPeriod = this.increaseBillingPeriod(this.getCurrentPeriod());
            }
            this.createObjPart(changePackageInstruction, true).then(
                (response) => {
                    this.showSuccess("Regrade successfully submitted");
                    this.getSale();
                },
                (error) => {
                    console.error(error);
                    this.showError("Error with Regrade Instruction", error);
                }
            );
        },
    }
}
</script>

<style lang="scss" scoped>
.sale-button {
    text-align: left;
    cursor: pointer; 
    background-color: #edf1f2;

    &:hover {
        color: #1b72e2;
        border: 1px solid #1b72e2;
    }
}
</style>